/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * htoken API
 * OpenAPI spec version: v1
 */
export const OnboardingDtoStatus = {
    NOT_STARTED: 'NOT_STARTED',
    STARTED: 'STARTED',
    DONE: 'DONE',
};
//# sourceMappingURL=onboardingDtoStatus.js.map